// extracted by mini-css-extract-plugin
export default {"select":"styles_select__QK874","title":"styles_title__3t2u3"};